import theme from '@/constants/theme';
import './style.css';

interface Props {
  style?: React.CSSProperties;
  color?: string;
  width?: number;
}

const Spinner: React.FC<Props> = ({ style = {}, color = theme.colors.secondary, width = 24 }) => {
  return <span className="spinner_loader" style={{ ...style, borderBottomColor: color, width }}></span>;
};

export default Spinner;
